import { CHROME_WEB_STORE_URL } from "../config";
export function InstallButton({ compact = false }: { compact?: boolean }) {
  if (CHROME_WEB_STORE_URL)
    return (
      <a
        className={`button button--primary ${compact ? "button--compact" : ""}`}
        href={CHROME_WEB_STORE_URL}
        target="_blank"
        rel="noreferrer"
      >
        Add to Chrome — Free <span aria-hidden="true">↗</span>
      </a>
    );
  return (
    <span className="install-pending">
      <button
        className={`button button--primary ${compact ? "button--compact" : ""}`}
        type="button"
        disabled
      >
        Add to Chrome — Free
      </button>
      <small>Chrome Web Store — Pending Review</small>
    </span>
  );
}
